import { HeaderTags } from "./HeaderTags";
import Slider from "./Slider";

const Header = () => {

  return (
    <header className="px-2 md:px-6 lg:px-0 my-4 flex flex-col gap-2 lg:grid lg:mx-20 lg:gap-3 lg:grid-cols-6">
      <Slider className=" h-3/5 " />
      <HeaderTags />
    </header>
  );
};
 
export default Header;
